import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UserModel } from 'projects/core/src/lib/models/user.model';

class CustomUserModel extends UserModel {
  rolenamelist: string;
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends BaseList implements OnInit {

  public users: Array<CustomUserModel> = [];

  protected rightLoad = 'admin.user.list';
  protected rightNew = 'admin.user.create';
  protected rightOpen = 'admin.user.show';
  protected apiUrl = '/users';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.users'));
    this.loading = true;
    this.api.getModels('users').subscribe({
      next: (users: any) => {
        this.users = [];
        users.data.forEach((user: any) => {
          user = new UserModel().deserialize(user);
          user.setTranslocoService(this.transloco);
          user.rolenamelist = user.translated_rolenames.join(' ');
          this.users.push(user);
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
